// import _BaseAPIService from "../_BaseAPIService"

// const instance = _BaseAPIService.instance;

// const UserExpired = () => ({
//   getUser: async() => {
//         try{
//             const response = await instance.get("/restrousersstats/expiring");
//             console.log("Summary Info Response: ",response.data);
//             return response.data;
//         }
//         catch(error){
//             console.log("Error fetching Summary Info",error);
//             throw error;
//         }
//     },
// });

// export default UserExpired

import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const UserExpired = () =>({
    getAll:async(days) => {
        try{
            const params = new URLSearchParams();
            console.log(params);
            if (days) params.append("days",days);
            const response = await instance.get(`/restrousersstats/expiring?${params.toString()}`);
            console.log("Full API response:", response);
            console.log("response.data:", response.data);


            console.log("Expired Users: ",response.data);
            return response.data;
        }
        catch(error){
            console.log("Error Fetching Expired Users",error);
            throw error;
        }
    }
});

export default UserExpired